import { FormBody } from 'twyne-new.ui';

import { DefaultGrid, GridProvider, useBuildGrid } from '@/components/Grid';
import { Refresh } from '@/components/Grid/components/header/Actions';
import { Wrapper, Search, Separator, Showing, Total, GridToggles } from '@/components/Grid/components/header/Heading';

import { useBucketStore } from '../../store';

import useColumns from './useColumns';
import useDefinitions from './useDefinitions';

function BucketsGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
  })

  return <DefaultGrid
    className='h-full'
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Separator />
      <Refresh />
    </Wrapper>}
    filters={null}
  />
}

export default function BucketsGridLayout() {
  return <GridProvider store={useBucketStore()}>
    <FormBody className='pb-4 h-full'>
      <div className='twy-bg-base-accent shadow rounded h-full'>
        <BucketsGrid />
      </div>
    </FormBody>
  </GridProvider>
}
